import {
  ensureContrast,
  getTagBorderColor,
  getTagFillColor,
} from '@ardoq/color-helpers';
import { ComponentRepresentationData } from '@ardoq/basic-components';
import { colors } from '@ardoq/design-tokens';
import { getIcon } from '@ardoq/icons';
import { APIComponentAttributes, APIComponentType } from '@ardoq/api-types';
import { componentOperations } from '@ardoq/core';

type ComponentRepresentationDataWithColorVariants =
  ComponentRepresentationData & {
    shadedColor: string;
    lightenedColor: string;
    contrastColor: string;
  };

export const getRepresentationDataWithColorVariants = (
  representationData: ComponentRepresentationData
): ComponentRepresentationDataWithColorVariants => {
  const tagFillColor = getTagFillColor(representationData.color);
  const tagBorderColor = getTagBorderColor(representationData.color);
  const contrastColor = ensureContrast(tagFillColor, representationData.color);
  return {
    ...representationData,
    lightenedColor: tagFillColor,
    contrastColor,
    shadedColor: tagBorderColor,
  };
};

export const getRepresentationDataWithColorVariantsForComponent = (
  component: APIComponentAttributes,
  componentType: APIComponentType | null
): ComponentRepresentationDataWithColorVariants => {
  const repData = componentOperations.getRepresentationData(
    component,
    componentType
  );
  const color =
    componentOperations.getColor(component, componentType) ?? colors.black950;
  return getRepresentationDataWithColorVariants({
    isImage: repData.isImage,
    value: repData.value ?? '',
    icon: repData.icon ?? getIcon(null),
    color,
  });
};
